<template>
	<div></div>
</template>

<script>
	export default {
		name: 'QuestionFiller',
		props: ['data', 'questionKey'],
		data() {
			return {};
		},
		computed: {},

		methods: {},
		components: {},
	};
</script>

<style></style>
